module.exports = __webpack_public_path__ + "media/legendary.7d97eea3.mp3";